import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-wavesawtooth",
  "use": "icon-th-wavesawtooth-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-wavesawtooth\">\n<path d=\"M29.5239 16.8512L16.5239 24.8512C16.3724 24.9444 16.1988 24.9954 16.021 24.9991C15.8432 25.0029 15.6677 24.9591 15.5124 24.8724C15.3572 24.7856 15.2278 24.6591 15.1378 24.5057C15.0478 24.3524 15.0002 24.1778 15.0001 24V9.78999L3.52386 16.8512C3.29847 16.98 3.03184 17.0161 2.78033 16.9518C2.52883 16.8876 2.31216 16.728 2.17613 16.507C2.04011 16.2859 1.99538 16.0206 2.05141 15.7671C2.10743 15.5136 2.25982 15.2919 2.47636 15.1487L15.4764 7.14874C15.6279 7.0556 15.8014 7.00454 15.9792 7.00083C16.157 6.99711 16.3326 7.04088 16.4878 7.1276C16.6431 7.21433 16.7724 7.34089 16.8624 7.49423C16.9525 7.64758 17 7.82216 17.0001 7.99999V22.21L28.4764 15.1487C28.7018 15.02 28.9684 14.9839 29.2199 15.0482C29.4714 15.1124 29.6881 15.2719 29.8241 15.493C29.9601 15.7141 30.0048 15.9794 29.9488 16.2329C29.8928 16.4863 29.7404 16.7081 29.5239 16.8512Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-wavesawtooth.svg
// module id = FUB1
// module chunks = 84